export default {
	consultantTitle: 'انتخاب مشاور',
	consultantDescription: 'برای رزرو وقت مشاوره، ابتدا مشاور مورد نظر خود را انتخاب کنید.',
	serviceTitle: 'انتخاب سرویس',
	serviceDescription: 'از سرویس‌هایی که مشاور انتخابی شما ارائه می‌دهد یکی را انتخاب کنید.',
	dateTitle: 'انتخاب ساعت',
	dateDescription: 'در چه روزی و چه ساعتی نیاز به مشاوره دارید؟ آن را انتخاب کنید و وقت خود را رزرو کنید.',
	formTitle: 'مشخصات فردی',
	formDescription: 'با تکمیل مشخصات، وقت رزرو شده خود را نهایی کنید و برای پرداخت تایید کنید.',
	paymentButton: 'تایید مشخصات و پرداخت',

	profile:{
		consultant:'مشاور:',
		service:'سرویس:',
		dateOfConsultation:'تاریخ مشاوره:',
		consultationHours:'ساعت مشاوره:'
	},

	am:'قبل ظهر',
	pm:'بعد از ظهر',

	dateError:'در تاریخ انتخابی مشاور در دسترس نمی‌باشد',

	successPayment:'پرداخت شما با موفقیت انجام شد و وقت با جزئیات زیر رزرو شد.',
	optionalService:'سرویس‌ انتخابی',
	failedPaymentButton:'تلاش دوباره برای پرداخت'

}
